/* ============================================================
   OLIVER'S GOLD — og.js
   One file. No dependencies. Safe to defer.

   Owns five things:
     1. reveal on scroll
     2. FAQ accordions
     3. the product configurator (variant, price, add-ons)
     4. the photo upload, including the crop preview
     5. add to cart, and the sticky bar on phones
   ============================================================ */
(function () {
  'use strict';

  document.documentElement.setAttribute('data-og-js', '');

  var money = function (cents, fmt) {
    var v = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return (fmt || '${{amount}}').replace(/\{\{\s*amount\s*\}\}/, v.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  };

  /* ---------- 1. reveal ---------------------------------- */
  function reveal() {
    var els = document.querySelectorAll('.og [data-rv]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- 2. accordions ------------------------------ */
  function accordions() {
    document.querySelectorAll('.og [data-og-acc] > button').forEach(function (btn) {
      if (btn.dataset.ogBound) return;
      btn.dataset.ogBound = '1';
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        var panel = btn.nextElementSibling;
        if (panel) panel.hidden = open;
      });
    });
  }

  /* ---------- 3, 4, 5. the product form ------------------ */
  function product(root) {
    if (root.dataset.ogBound) return;
    root.dataset.ogBound = '1';

    var dataEl = root.querySelector('[data-og-variants]');
    if (!dataEl) return;

    var variants = JSON.parse(dataEl.textContent);
    var cfg = JSON.parse(root.querySelector('[data-og-config]').textContent);
    var form = root.querySelector('form[data-og-form]') || root.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    /* Look elements up on every use rather than caching them. Storefront
       apps on this shop rewrite parts of the product form after load —
       the add to cart button's children among them — and a cached node
       goes detached, so writes land somewhere the customer cannot see. */
    var $ = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return root.querySelectorAll(s); };

    /* Variant images only carry information when they differ. Here every
       variant points at the same old photo, so swapping on selection
       would drop that photo over the gallery hero on the first click. */
    var distinct = {};
    variants.forEach(function (vv) {
      if (vv.featured_image && vv.featured_image.src) distinct[vv.featured_image.src] = 1;
    });
    var swapOnVariant = Object.keys(distinct).length > 1;

    /* the footer needs clearance under the fixed bar on phones */
    if ($('[data-og-sticky]')) {
      document.documentElement.classList.add('og-has-sticky');
    }

    var state = { options: {}, addons: {} };

    root.querySelectorAll('[data-og-opt]:checked').forEach(function (i) {
      state.options[i.getAttribute('data-og-opt')] = i.value;
    });

    function currentVariant() {
      var names = cfg.optionNames;
      return variants.find(function (v) {
        return names.every(function (n, i) {
          return !state.options[n] || v.options[i] === state.options[n];
        });
      }) || null;
    }

    function addonTotal() {
      return Object.keys(state.addons).reduce(function (sum, k) {
        return sum + (state.addons[k] ? state.addons[k].price : 0);
      }, 0);
    }

    function setLabel(text) {
      var lbl = $('[data-og-submit-label]'), btn = $('[data-og-submit]');
      if (lbl) lbl.textContent = text;
      else if (btn) btn.textContent = text;
    }

    function render() {
      var v = currentVariant();

      var submitEl = $('[data-og-submit]');
      var submitPrice = $('[data-og-submit-price]');

      /* grey out combinations that do not exist */
      $$('[data-og-opt]').forEach(function (input) {
        var name = input.getAttribute('data-og-opt');
        var probe = Object.assign({}, state.options);
        probe[name] = input.value;
        var exists = variants.some(function (vv) {
          return cfg.optionNames.every(function (n, i) { return vv.options[i] === probe[n]; }) && vv.available;
        });
        var label = input.closest('label') || $('label[for="' + input.id + '"]');
        if (label) label.classList.toggle('og-sold', !exists);
      });

      if (!v) {
        if (submitEl) submitEl.disabled = true;
        setLabel(cfg.strings.unavailable);
        if (submitPrice) submitPrice.textContent = '';
        return;
      }

      var idInput = $('input[name="id"]');
      if (idInput) idInput.value = v.id;
      var total = v.price + addonTotal();

      $$('[data-og-price]').forEach(function (el) { el.textContent = money(total, cfg.moneyFormat); });

      var wasEl = $('[data-og-was]');
      if (wasEl) {
        wasEl.hidden = !(v.compare_at_price && v.compare_at_price > v.price);
        if (!wasEl.hidden) wasEl.textContent = money(v.compare_at_price + addonTotal(), cfg.moneyFormat);
      }
      var splitEl = $('[data-og-split]');
      if (splitEl) {
        splitEl.textContent = cfg.strings.split.replace('[amount]', money(Math.round(total / 4), cfg.moneyFormat));
      }

      /* swap the gallery to the variant image, but only when variants
         actually have different images to swap to */
      if (swapOnVariant && v.featured_image && v.featured_image.src) {
        var main = $('[data-og-main] img');
        if (main) main.src = v.featured_image.src;
      }

      if (submitEl) submitEl.disabled = !v.available;
      setLabel(v.available ? cfg.strings.add : cfg.strings.soldout);
      if (submitPrice && cfg.priceInButton) {
        submitPrice.innerHTML = '&nbsp;&middot;&nbsp;' + money(total, cfg.moneyFormat);
      }

      /* keep the selected-value readouts in sync */
      Object.keys(state.options).forEach(function (n) {
        var out = $('[data-og-readout="' + n + '"]');
        if (out) out.textContent = state.options[n];
      });

      /* sticky bar summary, in the order the pickers are shown */
      var stickySub = $('[data-og-sticky-sub]');
      if (stickySub) {
        stickySub.textContent = cfg.optionNames
          .map(function (n) { return state.options[n]; })
          .filter(Boolean)
          .join(' · ');
      }
    }

    /* ---- option radios and add-on toggles ---- */
    root.addEventListener('change', function (e) {
      var t = e.target;

      if (t.matches('[data-og-opt]')) {
        state.options[t.getAttribute('data-og-opt')] = t.value;
        $$('[data-og-opt][name="' + t.name + '"]').forEach(function (r) {
          var l = r.closest('label');
          if (l) l.classList.toggle('is-on', r.checked);
        });
        render();
      }

      if (t.matches('[data-og-addon]')) {
        var id = t.getAttribute('data-og-addon');
        state.addons[id] = t.checked
          ? { id: id, price: parseInt(t.getAttribute('data-og-addon-price'), 10) || 0 }
          : null;
        var al = t.closest('label');
        if (al) al.classList.toggle('is-on', t.checked);
        render();
      }
    });

    /* ---- gallery thumbs ---- */
    $$('[data-og-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var main = $('[data-og-main] img');
        var img = btn.querySelector('img');
        if (main && img) main.src = img.getAttribute('data-og-full') || img.src;
        $$('[data-og-thumb]').forEach(function (b) { b.removeAttribute('aria-current'); });
        btn.setAttribute('aria-current', 'true');
      });
    });

    /* ---- photo upload ---- */
    var drop = $('[data-og-upload]');
    if (drop) {
      var file = drop.querySelector('input[type=file]');
      var nameEl = drop.querySelector('[data-og-filename]');
      var preview = $('[data-og-preview]');
      var previewImg = $('[data-og-preview-img]');
      var previewName = $('[data-og-preview-name]');
      var clearBtn = $('[data-og-upload-clear]');
      var MAX = 20 * 1024 * 1024;  /* Shopify's hard cap on a line item file */

      function clear() {
        file.value = '';
        drop.classList.remove('is-error');
        drop.hidden = false;
        if (nameEl) nameEl.textContent = '';
        if (preview) preview.hidden = true;
        if (previewImg) previewImg.removeAttribute('src');
      }

      function accept(f) {
        drop.classList.remove('is-error');
        if (!f) { clear(); return; }
        if (f.size > MAX) {
          drop.classList.add('is-error');
          if (nameEl) nameEl.textContent = cfg.strings.toobig;
          file.value = '';
          return;
        }
        if (nameEl) nameEl.textContent = f.name;
        if (previewName) previewName.textContent = f.name;

        /* show the photo inside a to-scale medallion so the customer
           sees roughly how it will crop before they order */
        if (preview && previewImg && window.FileReader) {
          var fr = new FileReader();
          fr.onload = function (ev) {
            previewImg.src = ev.target.result;
            preview.hidden = false;
            drop.hidden = true;
          };
          fr.readAsDataURL(f);
        }
      }

      file.addEventListener('change', function () { accept(file.files[0]); });
      if (clearBtn) clearBtn.addEventListener('click', clear);

      ['dragenter', 'dragover'].forEach(function (t) {
        drop.addEventListener(t, function (e) { e.preventDefault(); drop.classList.add('is-over'); });
      });
      ['dragleave', 'drop'].forEach(function (t) {
        drop.addEventListener(t, function (e) { e.preventDefault(); drop.classList.remove('is-over'); });
      });
      drop.addEventListener('drop', function (e) {
        if (!e.dataTransfer.files.length) return;
        file.files = e.dataTransfer.files;
        accept(file.files[0]);
      });
    }

    /* ---- add to cart ---- */
    form.addEventListener('submit', function (e) {
      if (!cfg.ajax) return;  /* let the browser post it, the reliable fallback */
      e.preventDefault();
      var errEl = $('[data-og-error]'), submitEl = $('[data-og-submit]');
      if (errEl) errEl.textContent = '';

      /* The form carries novalidate so the browser never enforces the
         required photo, and an AJAX post would sail through without it.
         Without this an order can arrive with nothing to set. */
      var fileInput = $('[data-og-upload] input[type=file]');
      if (fileInput && fileInput.required && !fileInput.files.length) {
        if (errEl) errEl.textContent = (cfg.strings && cfg.strings.nophoto) || 'Please add a photo first.';
        var zone = $('[data-og-upload]');
        if (zone) {
          zone.classList.add('is-error');
          zone.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }
        return;
      }

      if (submitEl) submitEl.disabled = true;
      setLabel(cfg.strings.adding);

      var fd = new FormData(form);
      fetch(cfg.routes.add, { method: 'POST', headers: { Accept: 'application/javascript' }, body: fd })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () {
          /* add-ons ride along as their own line items */
          var extra = Object.keys(state.addons)
            .filter(function (k) { return state.addons[k]; })
            .map(function (k) { return { id: parseInt(k, 10), quantity: 1 }; });
          if (!extra.length) return null;
          return fetch(cfg.routes.add, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: extra })
          });
        })
        .then(function () {
          if (cfg.afterAdd === 'cart') { window.location = cfg.routes.cart; return; }
          document.dispatchEvent(new CustomEvent('og:added'));
          setLabel(cfg.strings.added);
          setTimeout(function () { setLabel(cfg.strings.add); var b = $('[data-og-submit]'); if (b) b.disabled = false; }, 1800);
        })
        .catch(function (err) {
          var e2 = $('[data-og-error]'), b = $('[data-og-submit]');
          if (e2) e2.textContent = (err && err.description) || cfg.strings.error;
          if (b) b.disabled = false;
          setLabel(cfg.strings.add);
        });
    });

    render();
  }

  function init() {
    reveal();
    accordions();
    document.querySelectorAll('[data-og-product]').forEach(product);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Shopify theme editor re-renders sections without a page load */
  document.addEventListener('shopify:section:load', function (e) {
    var scope = e && e.target ? e.target : document;
    scope.querySelectorAll && scope.querySelectorAll('[data-og-product]').forEach(function (el) {
      delete el.dataset.ogBound;
    });
    init();
  });
})();
